export default function language() {
  $(document).ready(function() {
    var element = $('.selected.option').first()
    var language = element.attr('data-scr-language')
    $('#header div.container-select-block div.container-select img').attr('src', language)
  })
}
